export class BrandFilter {
  names?: string[];
}
